export default __webpack_public_path__ + "static/media/wht-cat-3.caabb3b8.svg";